import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {UserLoginContextProvider} from "./context/userLoginContext";
import {ErrorBoundary} from "react-error-boundary";
import {BrowserRouter} from "react-router-dom";
import SomethingWentWrong from "./pages/error-pages/something-went-wrong-error";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
    <BrowserRouter basename="/">
        <ErrorBoundary FallbackComponent={() => <SomethingWentWrong/>}>
            <UserLoginContextProvider>
                <App/>
            </UserLoginContextProvider>
        </ErrorBoundary>
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
